import { APP_ENV } from '@/common/const/env.const'

export const APP_CONFIG = {
  OPERATOR: 'WRODZINIE',
  [APP_ENV.development]: {
    API: '',
    SENTRY: ''
  },
  [APP_ENV.production]: {
    API: '',
    SENTRY: 'https://63077ed7a84144a8862eec79fc206404@error.blue.pl/126'
  }
}
